import { Component } from "react";
import axios from "axios";
import imageSrc from "./loginphotoGo.png";
import imageSrcCMK from "./loginphoto.png";
//import imageSrc from "./visuel-go-voice.png";
//import imageSrc2 from "./logo_govoice_h@2x.png";
import imageSrc2 from "./logo_govoice_h@2x.png";
import imageSrcCMK2 from "./logo.png";
import imageSrc3 from "./logo-go-mybiz.png";
import imageSrcCMK3 from "./cmk.png";
//import imageSrc3 from "./favicon-32x32.png";
import InputCode from "./InputCode";
import Languageselect from "./Languageselect";
import PuffLoader from "react-spinners/PuffLoader";
import CryptoJS from "crypto-js";
import { withTranslation } from "react-i18next";
import { Loader } from "react-feather";
import classNames from "classnames";
import { notification } from "antd";
//import { useTranslation, Trans, withTranslation } from "react-i18next";
//import { withTranslation } from "react-i18next";
// import { useTranslation } from "react-i18next";
// import { translate } from "react-i18next";
const BackendURL = window.BackendURLCmk;

function decryptC(text, shift = 3) {
  let result = "";

  const textLength = text.length;

  for (let i = 0; i < textLength; i++) {
    let char = text[i];

    if (/[a-zA-Z]/.test(char)) {
      let caseValue = /[A-Z]/.test(char) ? 65 : 97;

      result += String.fromCharCode(
        ((((char.charCodeAt(0) - shift - caseValue + 260) % 26) + 26) % 26) +
          caseValue
      );
    } else if (/\d/.test(char)) {
      result += String.fromCharCode(
        ((((char.charCodeAt(0) - shift - 48 + 260) % 10) + 10) % 10) + 48
      );
    } else {
      result += char;
    }
  }

  return result;
}
Date.prototype.yyyymmdd = function () {
  var mm = this.getMonth() + 1; // getMonth() is zero-based
  var dd = this.getDate();
  var hh = this.getHours();
  var mi = this.getMinutes();
  return [
    this.getFullYear(),
    (mm > 9 ? "" : "0") + mm,
    (dd > 9 ? "" : "0") + dd,
    (hh > 9 ? "" : "0") + hh,
  ].join("");
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.onChangeUserName = this.onChangeUserName.bind(this);
    this.onChangeUserEmail = this.onChangeUserEmail.bind(this);
    this.onChangeUsercompte = this.onChangeUsercompte.bind(this);

    ///////////////////login tel////////////////////
    this.firststeptel = this.firststeptel.bind(this);
    this.firststepmail = this.firststepmail.bind(this);

    this.onChangeUserEmail2 = this.onChangeUserEmail2.bind(this);
    this.onChangeUsertel = this.onChangeUsertel.bind(this);

    ///etatcon/////////////////////////////////
    this.etatconweb = this.etatconweb.bind(this);
    this.etatconmail = this.etatconmail.bind(this);
    this.etatcontel = this.etatcontel.bind(this);
    this.showHide = this.showHide.bind(this);
    this.loginByUsernamePassword = this.loginByUsernamePassword.bind(this);
    this.loginByTel = this.loginByTel.bind(this);
    this.loginByMail = this.loginByMail.bind(this);
    this.state = {
      classcssmail: "mail",
      compte: "",
      tel: "",
      email2: "",
      email: "",
      password: "",
      redirectToReferrer: false,
      type: "password",
      loading: false,
      error: false,
      errorBani: false,
      typecnx: "web",
      classcss: true,
      count: 0,
      error2: false,
      error3: false,
      error4: false,
      error21: false,
      key: "",
      key2: "",
      errortel: false,
      errormail: false,
      verified: false,
      selected: false,
    };
  }

  // verif user have a queue call
  verfiyQueueCall = ({ compte, poste, token }) => {
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/FileAttenteStatusIPBXV3API?compte=${compte}&poste=${poste}`,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        localStorage.setItem("HAS_QUEUE", res.data.membre_file_attente > 0);
      })
      .catch((err) => {
        localStorage.setItem("HAS_QUEUE", "false");
        console.log("AXIOS ERROR: ", err);
      });
  };
  // verif user have a queue call
  verfiyCallGroup = ({ compte, poste, token }) => {
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/GroupeAppelStatusIPBXV3API?compte=${compte}&poste=${poste}`,
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        localStorage.setItem(
          "HAS_CALL_GROUP",
          res.data.membre_groupe_appel > 0
        );
      })
      .catch((err) => {
        localStorage.setItem("HAS_CALL_GROUP", "false");
        console.log("AXIOS ERROR: ", err);
      });
  };

  onVerify = () => {
    this.setState({
      verified: true,
    });
  };
  firststeptel(e) {
    e.preventDefault();
    var config = {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
      },
    };
    this.setState({
      ...this.state,
      loading: true,
    });

    const { t } = this.props;

    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CompteUtilisateur?type_connexion=mobile&mobile=${this.state.tel}&mail=&login=&pwd=`,
        config
      )
      .then((res1) => {
        if (res1.data !== "UTILISATEUR_NON_EXISTANT") {
          localStorage.setItem("compte", res1.data.compte);
          localStorage.setItem("isWEB", res1.data.type_protocole);
          //var cpt = JSON.parse(res1.data);
          var config1 = {
            headers: {
              Authorization:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
            },
          };
          const result = axios
            .get(
              `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ConnexionEnvoiSmsEmailValidationAPI?compte=${res1.data.compte}&gsm_mail=${this.state.tel}`,
              config1
            )
            .then((res) => {
              if (res.data.etat_ws === "CODE_ENVOYER") {
                //  console.log("1", res.data.key);
                this.setState({ key: res.data.key });
                localStorage.setItem("key", res.data.key);
                this.setState({
                  ...this.state,
                  loading: false,
                  classcss: false,
                });
                // const data = res.data.carnet_adresse;
                // localStorage.setItem("tabcontact", JSON.stringify(data));

                // For displaying Data
              } else {
                this.setState({ error3: true });
              }
            })
            .catch((err) => {
              console.log("AXIOS ERROR: ", err);
              this.setState({ error2: true });
            });
        } else {
          notification["error"]({
            message: t("login.user_not_found"),
            placement: "topLeft",
            style: {
              marginTop: 40,
            },
          });

          this.setState({
            ...this.state,
            loading: false,
          });
        }
      })
      .catch((err) => {
        notification["error"]({
          message: t("login.errorApi"),
          placement: "topLeft",
          style: {
            marginTop: 40,
          },
        });
        this.setState({ ...this.state, loading: false });

        console.log("AXIOS ERROR: ", err);
      });
  }
  loginByTel(code) {
    var key = localStorage.getItem("key");
    var compte = localStorage.getItem("compte");

    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/KQSfjiunfoiejncijr299kcjdf?compte=${compte}&key=${key}&code=${code}`
      )
      .then((response) => {
        var date = new Date();

        // var decrypted =
        const SIP_ = decryptC(response.data.param_1)?.includes("_")
          ? decryptC(response.data.param_1)?.split("_")[1]
          : decryptC(response.data.param_1);
        const postMaster = decryptC(response.data.param_4);
        const idTag = CryptoJS.AES.encrypt(date.yyyymmdd(), "m@123").toString();
        const webphoneParam =
          response.data.param_1 +
          "/*/" +
          response.data.param_2 +
          "/*/" +
          response.data.param_3 +
          "/*/" +
          response.data.param_5 +
          "/*/" +
          response.data.param_6 +
          "/*/" +
          response.data.param_7;
        const infoTag = CryptoJS.AES.encrypt(
          webphoneParam,
          date.yyyymmdd()
        ).toString();
        localStorage.setItem("infoTag", infoTag);
        localStorage.setItem("AccessToken", response.data.AccessToken);
        localStorage.setItem("poste", SIP_);
        localStorage.setItem("posteMaster", postMaster);

        localStorage.setItem("idTag", idTag);
        this.verfiyQueueCall({
          compte,
          poste: SIP_,
          token: response.data.AccessToken,
        });
        this.verfiyCallGroup({
          compte,
          poste: SIP_,
          token: response.data.AccessToken,
        });

        var config = {
          headers: {
            Authorization: response.data.AccessToken,
          },
        };
        // carnet address
        axios
          .get(
            `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${SIP_}`,
            config
          )
          .then((res1) => {
            const data = res1.data.carnet_adresse;
            this.setState({
              ...this.state,
              loading: false,
            });
            localStorage.setItem("tabcontact", JSON.stringify(data));
            //  this.setState({ redirectToReferrer: true });
            this.getAllcollegue(compte, SIP_, response.data.AccessToken);

            // For displaying Data
          })
          .catch((err) => {
            this.setState({
              ...this.state,
              loading: false,
            });
            console.log("AXIOS ERROR: ", err);
          });
      })
      .catch((err) => {
        // this.setState({ count: this.state.count + 1 });
        console.log("AXIOS ERROR: ", err);
        this.setState({
          ...this.state,
          errortel: true,
          loading: false,
        });
      });
  }
  ////////////////////////////::login mail ///////////////////
  firststepmail(e) {
    e.preventDefault();
    var config = {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
      },
    };
    // console.log("heeeeeeeeeeeeee", this.state.email2);
    var lien = window.location.href;
    const var2 = lien.split("/");
    var var4 = var2[2].split(":");
    this.setState({
      ...this.state,
      loading: true,
    });
    const { t } = this.props;

    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CompteUtilisateur?type_connexion=mail&mobile=&mail=${this.state.email2}&login=&pwd=`,
        config
      )
      .then((res1) => {
        if (res1.data !== "UTILISATEUR_NON_EXISTANT") {
          //var cpt = JSON.parse(res1.data);
          localStorage.setItem("compte", res1.data.compte);
          localStorage.setItem("isWEB", res1.data.type_protocole);
          var config1 = {
            headers: {
              Authorization:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
            },
          };
          const result = axios
            .get(
              `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ConnexionEnvoiSmsEmailValidationAPI?compte=${res1.data.compte}&gsm_mail=${this.state.email2}&ip_address=192.168.30.8`,
              config1
            )
            .then((res) => {
              if (res.data.etat_ws === "CODE_ENVOYER") {
                localStorage.setItem("key2", res.data.key);
                this.setState({
                  ...this.state,
                  loading: false,
                  key2: res.data.key,
                  classcssmail: false,
                });
                // const data = res.data.carnet_adresse;
                // localStorage.setItem("tabcontact", JSON.stringify(data));

                // For displaying Data
              } else {
                this.setState({ ...this.state, error4: true });
              }
            })
            .catch((err) => {
              console.log("AXIOS ERROR: ", err);
              this.setState({ ...this.state, error21: true, loading: false });
            });
        } else {
          notification["error"]({
            message: t("login.user_not_found"),
            placement: "topLeft",
            style: {
              marginTop: 40,
            },
          });

          this.setState({
            ...this.state,
            loading: false,
          });
        }
      })
      .catch((err) => {
        notification["error"]({
          message: t("login.errorApi"),
          placement: "topLeft",
          style: {
            marginTop: 40,
          },
        });
        this.setState({
          ...this.state,
          loading: false,
        });

        console.log("AXIOS ERROR: ", err);
      });
  }
  loginByMail(code) {
    var key = localStorage.getItem("key2");
    var compte = localStorage.getItem("compte");

    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/KQSfjiunfoiejncijr299kcjdf?compte=${compte}&key=${key}&code=${code}`
      )
      .then((response) => {
        //  console.log("2", res.data);
        var date = new Date();

        // var decrypted =
        const SIP_ = decryptC(response.data.param_1)?.includes("_")
          ? decryptC(response.data.param_1)?.split("_")[1]
          : decryptC(response.data.param_1);
        const postMaster = decryptC(response.data.param_4);

        const idTag = CryptoJS.AES.encrypt(date.yyyymmdd(), "m@123").toString();
        const webphoneParam =
          response.data.param_1 +
          "/*/" +
          response.data.param_2 +
          "/*/" +
          response.data.param_3 +
          "/*/" +
          response.data.param_5 +
          "/*/" +
          response.data.param_6 +
          "/*/" +
          response.data.param_7;

        const infoTag = CryptoJS.AES.encrypt(
          webphoneParam,
          date.yyyymmdd()
        ).toString();
        localStorage.setItem("infoTag", infoTag);
        localStorage.setItem("AccessToken", response.data.AccessToken);
        localStorage.setItem("posteMaster", postMaster);

        localStorage.setItem("poste", SIP_);
        localStorage.setItem("idTag", idTag);

        this.verfiyQueueCall({
          compte,
          poste: SIP_,
          token: response.data.AccessToken,
        });
        this.verfiyCallGroup({
          compte,
          poste: SIP_,
          token: response.data.AccessToken,
        });

        var config = {
          headers: {
            Authorization: response.data.AccessToken,
          },
        };
        // this.getAllcontact(compte, res.data.sip, res.data.AccessToken);
        axios
          .get(
            `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${SIP_}`,
            config
          )
          .then((res1) => {
            const data = res1.data.carnet_adresse;

            localStorage.setItem("tabcontact", JSON.stringify(data));
            //  this.setState({ redirectToReferrer: true });
            this.getAllcollegue(compte, SIP_, response.data.AccessToken);

            // For displaying Data
          })
          .catch((err) => {
            console.log("AXIOS ERROR: ", err);
          });

        // this.getallgrpcoleegue(compte, res.data.sip, res.data.AccessToken);

        // localStorage.setItem("name", name);
        // localStorage.setItem("pwd", pwd);
        // localStorage.setItem("port", port);
        // localStorage.setItem("ip", ip);

        //  ;
      })
      .catch((err) => {
        // this.setState({ count: this.state.count + 1 });
        console.log("AXIOS ERROR: ", err);
        this.setState({ errortel: true });
      });
  }
  /////////////////login code//////////////////////////
  /////////////////////////////////////////////////////////////////////////////
  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "input" ? "password" : "input",
    });
  }
  onChangeUserName(e) {
    this.setState({ password: e.target.value });
  }
  onChangeUsertel(e) {
    this.setState({ tel: e.target.value });
  }
  onChangeUserEmail(e) {
    this.setState({ email: e.target.value });
  }
  onChangeUserEmail2(e) {
    this.setState({ email2: e.target.value });
  }
  onChangeUsercompte(e) {
    this.setState({ compte: e.target.value });
  }
  etatconweb() {
    this.setState({ typecnx: "web" });
  }
  etatcontel() {
    this.setState({ typecnx: "tel" });
    //this.setState({ classcss: true });
  }
  etatconmail() {
    this.setState({ typecnx: "mail" });
  }

  getipadress = async () => {
    const result = axios
      .get("https://jsonip.com/?callback=")
      .then((res) => {
        // const ip = res.ip;
        console.log(res.data.ip);

        //  localStorage.setItem("tabcontact", JSON.stringify(data));

        // For displaying Data
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  getAllcontact = (compte, poste, token) => {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const data = res.data.carnet_adresse;

        localStorage.setItem("tabcontact", JSON.stringify(data));
        //  this.setState({ redirectToReferrer: true });

        // For displaying Data
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  getAllcollegue = (compte, poste, token) => {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3APIPROFIL?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const data = res.data.collegues;
        localStorage.setItem("tabcollegue", JSON.stringify(data));
        // this.setState({ redirectToReferrer: true });
        //  this.setState({ redirectToReferrer: true });
        //  this.setState({ redirectToReferrer: true });
        this.getallgrpcoleegue(compte, poste, token);
        // For displaying Data
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  getallgrpcoleegue = (compte, poste, token) => {
    var config = {
      headers: {
        Authorization: token,
      },
    };
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    const result = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/GroupeAppelIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const data = res.data;
        localStorage.setItem("tabgrcollegue", JSON.stringify(data));
        // this.setState({ redirectToReferrer: true });
        //  this.setState({ redirectToReferrer: true });
        this.setState({ redirectToReferrer: true });
        // For displaying Data
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };

  loginByUsernamePassword(e) {
    e.preventDefault();
    localStorage.clear();
    var config = {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
      },
    };
    this.setState({
      ...this.state,
      loading: true,
    });

    const { t } = this.props;

    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CompteUtilisateur?type_connexion=web&mobile=&login=${this.state.email}&pwd=${this.state.password}`,
        config
      )
      .then((res1) => {
        if (res1.data !== "UTILISATEUR_NON_EXISTANT") {
          if (res1.data === "BANI") {
            this.setState({ ...this.state, errorBani: true });
          } else {
            localStorage.setItem("isWEB", res1.data.type_protocole);

            //test///////////////////
            var config1 = {
              headers: {
                Authorization:
                  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
              },
            };

            axios
              .get(
                `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ConnexionIPBXV3API?compte=${res1.data.compte}&login=${this.state.email}&passwd=${this.state.password}`,
                config1
              )
              .then((res) => {
                //console.log(res.data);
                const AccessToken = res.data.AccessToken;
                localStorage.setItem("AccessToken", AccessToken);
                localStorage.setItem("compte", res.data.compte);
                const poste = res.data.poste?.includes("_")
                  ? res.data.poste?.split("_")[1]
                  : res.data.poste;
                localStorage.setItem("poste", poste);
                localStorage.setItem(
                  "posteMaster",
                  res.data.poste_associer_master
                );
                this.verfiyQueueCall({
                  compte: res1.data.compte,
                  poste: poste,
                  token: AccessToken,
                });
                this.verfiyCallGroup({
                  compte: res1.data.compte,
                  poste: poste,
                  token: AccessToken,
                });

                this.getAllcontact(
                  res.data.compte,
                  res.data.poste,
                  res.data.AccessToken
                );
                this.getAllcollegue(
                  res.data.compte,
                  res.data.poste,
                  res.data.AccessToken
                );
                // this.getallgrpcoleegue(
                //   res.data.compte,
                //   res.data.poste,
                //   res.data.AccessToken
                // );
                var config = {
                  headers: {
                    Authorization: res.data.AccessToken,
                  },
                };
                axios
                  .get(
                    ///////WS/////////
                    `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/Etncuje3kifh698dh13?98sfdh3hjf=${res1.data.compte}&DSf536kv90=${this.state.email}&48772Jhcbz=${this.state.password}&39Jehgr2=${res.data.poste}`,
                    config
                  )
                  .then((response) => {
                    var date = new Date();
                    const idTag = CryptoJS.AES.encrypt(
                      date.yyyymmdd(),
                      "m@123"
                    ).toString();

                    const webphoneParam =
                      response.data.param_1 +
                      "/*/" +
                      response.data.param_2 +
                      "/*/" +
                      response.data.param_3 +
                      "/*/" +
                      response.data.param_5 +
                      "/*/" +
                      response.data.param_6 +
                      "/*/" +
                      response.data.param_7;
                    const infoTag = CryptoJS.AES.encrypt(
                      webphoneParam,
                      date.yyyymmdd()
                    ).toString();
                    localStorage.setItem("infoTag", infoTag);
                    localStorage.setItem("idTag", idTag);

                    this.setState({ ...this.state, loading: false });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              })
              .catch((res) => {
                console.log(res);
                this.setState({ ...this.state, loading: false });

                //console.log(error);
                // <Popup />;
              });
            //fin test//////////////
          }
        } else {
          notification["error"]({
            message: t("login.user_not_found"),
            placement: "topLeft",
            style: {
              marginTop: 40,
            },
          });
          this.setState({
            ...this.state,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.log("here", error);
        notification["error"]({
          message: t("login.errorApi"),
          placement: "topLeft",
          style: {
            marginTop: 40,
          },
        });
        this.setState({ ...this.state, loading: false });
      });
  }
  render() {
    const { t } = this.props;
    // const eye = (
    //   <svg
    //     xmlns="http://www.w3.org/2000/svg"
    //     className="h-6 w-6"
    //     fill="none"
    //     viewBox="0 0 24 24"
    //     stroke="currentColor"
    //   >
    //     <path
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       strokeWidth="2"
    //       d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    //     />
    //     <path
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //       strokeWidth="2"
    //       d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    //     />
    //   </svg>
    // );
    const { loading } = this.state;
    if (this.state.redirectToReferrer === true) {
      return (
        <div className="flex justify-center mt-64">
          <PuffLoader color="#109669" size={150} width={8} height={204} />

          {window.location.reload()}
        </div>
      );
    } else {
      return (
        <div className="min-h-screen bg-white flex">
          <Languageselect
            toggle={this.props.toggle1}
            style={{ zIndex: "9999" }}
          />
          <div className="flex-1 flex flex-col justify-center -ml-16">
            {/* <img
              className="absolute inset-0 h-full w-full object-cover"
              src={imageSrc4}
              alt=""
            /> */}

            {/* <div>
              <button onClick={() => this.changeLanguage("de")}>de</button>
              <button onClick={() => this.changeLanguage("en")}>en</button>
            </div> */}
            <div className="mx-auto w-full max-w-sm lg:w-96">
              <div className="sm:mx-auto sm:w-full sm:max-w-md">
                {/* <h6 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Go Voice</h6> */}
                <img
                  className="mx-auto"
                  src={
                    window.switchAPI === "govoice" ? imageSrc2 : imageSrcCMK2
                  }
                  alt="Workflow"
                />
                {/* <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Connectez-vous</h2> */}
                {/* <div className="relative flex justify-center text-sm">
                  <span className="px-2 ml-20 -mt-1 bg-white text-gray-400">
                    version 3.1
                  </span>
                </div> */}
              </div>
              <div className="flex-1 flex  justify-center mt-8">
                <button
                  data-tip
                  data-for="infoTip"
                  type="button"
                  onClick={this.etatconweb}
                  className={
                    this.state.typecnx == "web"
                      ? "mr-2  border-b border-green-500   inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-green-500  bg-gray-100 hover:text-green-400   focus:outline-none"
                      : "mr-2  inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-400   focus:outline-none"
                  }
                >
                  <svg
                    className="w-7 h-7"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                    ></path>
                  </svg>
                </button>
                <button
                  data-tip
                  data-for="infoTip"
                  type="button"
                  onClick={this.etatcontel}
                  className={
                    this.state.typecnx == "tel"
                      ? "mr-2  border-b border-green-400   inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-green-400   bg-gray-100 hover:text-green-400   focus:outline-none"
                      : "mr-2  inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-400   focus:outline-none"
                  }
                >
                  <svg
                    className="w-7 h-7"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                    ></path>
                  </svg>
                </button>
                <button
                  data-tip
                  data-for="infoTip"
                  type="button"
                  onClick={this.etatconmail}
                  className={
                    this.state.typecnx == "mail"
                      ? "mr-2  border-b border-green-400   inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-green-400   bg-gray-100 hover:text-green-400   focus:outline-none"
                      : "mr-2  inline-flex items-center p-2 border rounded-lg border-transparent shadow-sm text-xs font-medium text-gray-400 bg-gray-100 hover:text-green-400   focus:outline-none"
                  }
                >
                  <svg
                    className="w-7 h-7"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    ></path>
                  </svg>
                </button>
              </div>

              <div className="mt-8">
                <div className="mt-6">
                  {this.state.typecnx == "web" ? (
                    <form
                      className="space-y-6"
                      onSubmit={this.loginByUsernamePassword}
                    >
                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium text-gray-700"
                        >
                          {t("username")}
                        </label>
                        <div className="mt-1">
                          <input
                            placeholder={t("username_placeholder")}
                            id="email"
                            name="email"
                            type="text"
                            value={this.state.email}
                            onChange={this.onChangeUserEmail}
                            autoComplete="email"
                            required
                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-400 focus:border-green-400sm:text-sm"
                          />
                        </div>
                      </div>
                      {/* <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Compte
                      </label>
                      <div className="mt-1">
                        <input
                          id="email"
                          name="email"
                          type="text"
                          value={this.state.compte}
                          onChange={this.onChangeUsercompte}
                          autoComplete="email"
                          required
                          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-igreenndigo-500 focus:border-green-500 sm:text-sm"
                        />
                      </div>
                    </div> */}

                      <div>
                        <label
                          htmlFor="password"
                          className="block text-sm font-medium text-gray-700"
                        >
                          {t("password")}
                        </label>
                        <div className="mt-1 relative">
                          <input
                            id="password"
                            name="password"
                            placeholder={t("password_placeholder")}
                            type={this.state.type}
                            value={this.state.password}
                            onChange={this.onChangeUserName}
                            autoComplete="current-password"
                            required
                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-400focus:border-green-400sm:text-sm"
                          />
                          <span
                            onClick={this.showHide}
                            className="absolute inset-y-0 right-2 pl-3 flex items-center"
                          >
                            {this.state.type === "input" ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-green-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-gray-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                                />
                              </svg>
                            )}
                          </span>
                        </div>
                      </div>
                      {/* <Reaptcha
                        sitekey="6Lfe2w8dAAAAALreCak8G6SmJ0e-ZoSLWrBq07_l"
                        onVerify={this.onVerify}
                      /> */}

                      <button
                        type="submit"
                        disabled={this.state.loading}
                        className={`
                      
                      w-full flex justify-center py-2 px-4 border border-transparent space-x-2 rounded-full shadow-sm text-sm font-medium text-white ${
                        this.state.loading ? "bg-gray-500" : "bg-green-500"
                      }
                      `}
                      >
                        {this.state.loading && (
                          <Loader className=" animate-spin" />
                        )}
                        <span
                          className={classNames(
                            this.state.loading
                              ? "opacity-25 cursor-not-allowed  "
                              : "hover:bg-govoicegreen2  focus:outline-none focus:ring-2 focus:ring-offset-2 bg-green-500 focus:ring-green-400  ",
                            "text-white bg-transparent"
                          )}
                        >
                          {t("connexion")}
                        </span>
                      </button>
                      {this.state.error ? (
                        <div
                          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                          role="alert"
                        >
                          <span className="block sm:inline">
                            {t("mailorpass")}
                          </span>
                          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                            <svg
                              className="fill-current h-6 w-6 text-red-500"
                              role="button"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <title>Close</title>
                              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                            </svg>
                          </span>
                        </div>
                      ) : (
                        <div></div>
                      )}
                      {this.state.errorBani ? (
                        <div
                          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                          role="alert"
                        >
                          <span className="block sm:inline">{t("banne")}</span>
                          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                            <svg
                              className="fill-current h-6 w-6 text-red-500"
                              role="button"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <title>Close</title>
                              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                            </svg>
                          </span>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </form>
                  ) : (
                    <div></div>
                  )}

                  {this.state.typecnx == "tel" ? (
                    <>
                      {this.state.classcss ? (
                        <form onSubmit={this.firststeptel}>
                          <label
                            htmlFor="number"
                            className="pb-4 block text-sm font-medium text-gray-700"
                          >
                            {t("phonenumber")}
                          </label>

                          <input
                            id="email"
                            name="email"
                            type="text"
                            placeholder={t("urphonenumber")}
                            value={this.state.tel}
                            onChange={this.onChangeUsertel}
                            autoComplete="email"
                            required
                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-400focus:border-green-400sm:text-sm"
                          />
                          <div>
                            <button
                              disabled={this.state.loading}
                              type="submit"
                              className={`
                              mt-4
                      w-full flex justify-center py-2 px-4 border border-transparent space-x-2 rounded-full shadow-sm text-sm font-medium text-white ${
                        this.state.loading ? "bg-gray-500" : "bg-green-500"
                      }
                      `}
                            >
                              {this.state.loading && (
                                <Loader className=" animate-spin" />
                              )}
                              {t("connexion")}
                            </button>

                            {this.state.error2 ? (
                              <div
                                className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                                role="alert"
                              >
                                <span className="block sm:inline">
                                  {t("wrongnimber")}{" "}
                                </span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                  <svg
                                    className="fill-current h-6 w-6 text-red-500"
                                    role="button"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <title>{t("close")}</title>
                                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                  </svg>
                                </span>
                              </div>
                            ) : (
                              <div></div>
                            )}

                            {this.state.error3 ? (
                              <div
                                className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                                role="alert"
                              >
                                <span className="block sm:inline">
                                  vous avez atteint le nombre maximum de
                                  tentatives d'envoi d'sms
                                </span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                  <svg
                                    className="fill-current h-6 w-6 text-red-500"
                                    role="button"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <title>{t("close")}</title>
                                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                  </svg>
                                </span>
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </form>
                      ) : (
                        <div className="">
                          <h2 className="text-xl font-bold leading-7 text-gray-900 sm:text-3xl px-2 py-4 sm:truncate">
                            {t("Authentification")}
                          </h2>

                          <span className="px-2 py-4 border-gray-400 text-gray-400 group inline-flex items-center font-medium text-sm">
                            {t("confirmationcode")}
                          </span>
                          <div className="flex-1 flex  justify-center">
                            <InputCode
                              length={6}
                              label="Code Label"
                              loading={loading}
                              onComplete={(code) => {
                                this.loginByTel(code);
                              }}
                            />
                          </div>
                          {this.state.errortel ? (
                            <div
                              className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                              role="alert"
                            >
                              <span className="block sm:inline">
                                {t("codeincorrect")}
                              </span>
                              <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                <svg
                                  className="fill-current h-6 w-6 text-red-500"
                                  role="button"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <title>Close</title>
                                  <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                </svg>
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {this.state.typecnx == "mail" ? (
                    <>
                      {this.state.classcssmail ? (
                        <form onSubmit={this.firststepmail}>
                          <label
                            htmlFor="email"
                            className="pb-4 block text-sm font-medium text-gray-700"
                          >
                            {t("e-mail")}
                          </label>

                          <input
                            id="email"
                            name="email"
                            type="text"
                            placeholder={t("urmailadresse")}
                            value={this.state.email2}
                            onChange={this.onChangeUserEmail2}
                            autoComplete="email"
                            required
                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-400focus:border-green-400sm:text-sm"
                          />
                          <div>
                            <button
                              type="submit"
                              disabled={this.state.loading}
                              className={`
                      mt-4
                      w-full flex justify-center py-2 px-4 border border-transparent space-x-2 rounded-full shadow-sm text-sm font-medium text-white ${
                        this.state.loading ? "bg-gray-500" : "bg-green-500"
                      }
                      `}
                            >
                              {this.state.loading && (
                                <Loader className=" animate-spin" />
                              )}
                              {t("connexion")}
                            </button>
                            {this.state.error21 ? (
                              <div
                                className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                                role="alert"
                              >
                                <span className="block sm:inline">
                                  {t("wrongmail")}{" "}
                                </span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                  <svg
                                    className="fill-current h-6 w-6 text-red-500"
                                    role="button"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <title>{t("close")}</title>
                                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                  </svg>
                                </span>
                              </div>
                            ) : (
                              <></>
                            )}

                            {this.state.error4 ? (
                              <div
                                className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                                role="alert"
                              >
                                <span className="block sm:inline">
                                  vous avez atteint le nombre maximum de
                                  tentatives d'envoi de code
                                </span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                  <svg
                                    className="fill-current h-6 w-6 text-red-500"
                                    role="button"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                  >
                                    <title>{t("close")}</title>
                                    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                  </svg>
                                </span>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </form>
                      ) : (
                        <div className="">
                          <h2 className="text-xl font-bold leading-7 text-gray-900 sm:text-3xl px-2 py-4 sm:truncate">
                            {t("mailauth")}
                          </h2>

                          <span className="px-2 py-2 border-gray-400 text-gray-400 group inline-flex items-center  font-medium text-sm">
                            {t("confirmationcode")}{" "}
                          </span>
                          <div className="flex-1 flex  justify-center">
                            <InputCode
                              length={6}
                              label="Code Label"
                              loading={loading}
                              onComplete={(code) => {
                                this.loginByMail(code);
                              }}
                            />
                          </div>
                          {this.state.errormail ? (
                            <div
                              className="flex-1 flex justify-center mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-xl relative"
                              role="alert"
                            >
                              <span className="block sm:inline">
                                {t("codeincorrect")}
                              </span>
                              <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
                                <svg
                                  className="fill-current h-6 w-6 text-red-500"
                                  role="button"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <title>{t("close")}</title>
                                  <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
                                </svg>
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="mt-6 relative">
                    <div
                      className="absolute inset-0 flex items-center"
                      aria-hidden="true"
                    >
                      <div />
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="px-2 bg-white text-gray-400">
                        {window.switchAPI === "govoice"
                          ? "2020-" +
                            new Date().getFullYear() +
                            " © Powered by GO MYBIZ"
                          : "2008-" +
                            new Date().getFullYear() +
                            " © Powered COMUNIK-CRM"}
                        {/* 2020 -2021 © Powered by GO MYBIZ */}
                      </span>
                      <div className="w-6 h-6">
                        <img
                          className="mx-auto"
                          src={
                            window.switchAPI === "govoice"
                              ? imageSrc3
                              : imageSrcCMK3
                          }
                          alt="Workflow"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden lg:block relative w-0 flex-1">
            <img
              className="absolute inset-0 h-full w-full object-cover"
              src={window.switchAPI === "govoice" ? imageSrc : imageSrcCMK}
              alt=""
            />
          </div>
        </div>
      );
    }
  }
}

//export default injectIntl(connect(null, auth.actions)(Login));
export default withTranslation("common")(Login);
// Login.propTypes = {
//   setToken: PropTypes.func.isRequired,
// };
